let inject = [
  '$scope',
  'SharedService',
  '$state',
  '$rootScope',
  '$timeout'
];

class HomeController{
  constructor ($scope, SharedService, $state, $rootScope, $timeout) {
    this.$state = $state;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;
  }

  $onInit() {
	this.shCtrl.activate();
  }

}

HomeController.$inject = inject;

export default HomeController;




/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/home/home.controller.js
 **/